import { Box } from "@material-ui/core";
import { LabelOutlined, PermContactCalendarOutlined } from "@material-ui/icons";

import { useConnect } from "../../../context/connect";
import { TAgentNav } from "../../../interfaces";

import { useStyles } from "./style";

export const Nav = ({ type }: { type: TAgentNav }) => {
  const classes = useStyles();
  const { setAgentNav, agentNav, contact } = useConnect();

  const onHandlerClick = () => {
    setAgentNav(type);
  };

  let clx = classes.nav;

  if (agentNav === type) {
    clx = `${classes.nav} active`;
  }
  if (type === "customer_info" && !contact) {
    clx = `${classes.nav} inactive`;
  }

  const getIcon = () => {
    switch (type) {
      case "canned_responses":
        return <LabelOutlined />;

      case "customer_info":
        return <PermContactCalendarOutlined />;

      default:
        break;
    }
  };

  return (
    <Box className={clx} onClick={onHandlerClick}>
      <Box className={classes.nav_icon}>{getIcon()}</Box>
      <Box className={classes.nav_bottom}></Box>
    </Box>
  );
};
